RatesCtrl.$inject = ['$rootScope', '$scope'];
function RatesCtrl($rootScope, $scope) {

}

module.exports = RatesCtrl;


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/rates/controllers/rates.js
 ** module id = 282
 ** module chunks = 1
 **/